module.exports = __webpack_public_path__ + "img/dfod_k.4612f7f9.png";